import type { DashboardFinancieroResponse } from '@condo/contracts';
import { Calendar } from 'lucide-react';
import { formatClp } from '@/lib/format/currency';
import { formatLongDate, formatPeriodo } from '@/lib/format/date';

type Vencimiento = DashboardFinancieroResponse['proximosVencimientos'][number];

export function ProximosVencimientosFinanciero({
  items,
}: {
  items: Vencimiento[];
}) {
  if (items.length === 0) {
    return (
      <p className="text-sm text-[var(--color-ink-muted)]">
        Sin vencimientos pendientes.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-[var(--color-hairline-strong)] text-left text-[0.6875rem] font-semibold uppercase tracking-[0.12em] text-[var(--color-ink-faint)]">
            <th className="pb-3 pr-4">Periodo</th>
            <th className="pb-3 pr-4">Fecha vencimiento</th>
            <th className="pb-3 text-right">Monto pendiente</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-[var(--color-hairline)]">
          {items.map((v) => (
            <tr key={v.gastoId} className="group">
              <td className="py-3 pr-4">
                <span className="font-medium text-[var(--color-ink)]">
                  {formatPeriodo(v.periodo)}
                </span>
              </td>
              <td className="py-3 pr-4">
                <div className="flex items-center gap-2">
                  <Calendar className="h-3.5 w-3.5 shrink-0 text-[var(--color-ink-muted)]" />
                  <span className="text-[var(--color-ink-soft)]">
                    {formatLongDate(v.fechaVencimiento)}
                  </span>
                </div>
              </td>
              <td className="py-3 text-right">
                <span className="font-display-tight font-semibold text-[var(--color-ink)] tabular">
                  {formatClp(v.montoPendiente)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
